export const userHelper = {
    passwordMatch,
};

function passwordMatch (password1, password2) {
    return password1 === password2;
}
